export var emailLwkInitialState = {};
export var emailLwkSuccessState = {
    mailSend: true,
    message: {
        level: 'success',
        message: 'Ihre Nachricht wurde erfolgreich versendet.'
    }
};
export var emailLwkFailureState = {
    mailSend: false,
    message: {
        level: 'danger',
        message: 'Beim Versenden Ihrer Nachricht ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.'
    }
};
